import { IUser, SystemPreferencesResponse } from 'types';

/** Loyalty points UI: site flag + client is enrolled as a points member. */
export const shouldShowRewardPoints = (
  sysPrefs?: SystemPreferencesResponse | null,
  user?: IUser | null
): boolean => !!sysPrefs?.show_balance_points && user?.is_points_member === 1;
